import { Button, Container, Text, Title } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import colors from "../../../utils/styles";
const BookingFailure = () => {
  const navigate = useNavigate();

  return <Container size="responsive"
    styles={{
      root: {
        background: 'linear-gradient(180deg,#67bae7,#32549b 33%,#32549b 66%,#67bae7)',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }
    }}>
      <div style={{
        borderRadius: '10px',
        border: colors.appBorder,
        padding: '40px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <Title style={{
          fontWeight: 900,
          color: colors.appYellow,
          fontSize: '34px',
          marginBottom: 'md',
        }}>Booking failed
        </Title>
        <Text styles={{
          root: {
            color: colors.appWhite,
            textAlign: 'center',
          }
        }}>
          We are sorry, but there was an error processing your payment. Please try again.
        </Text>
        <Button
          style={{ backgroundColor: colors.appPink, boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.5)' }}
          onClick={() => navigate('/')} radius="xl" size="md" mt="xl">
          Back to home page
        </Button>
      </div>

  </Container>;
};

export default BookingFailure;
    